import { useMutation, useQuery } from '@tanstack/react-query';
import { Modal, Select, Table } from 'antd'
import Button from 'components/Button';
import { useState } from 'react';
import HTTPClient from 'services/HTTPClient';
import { GRADES, TOPICS, showErrorToast, showSuccessToast } from 'utils';

export const useApprovedQuestionTemplates = (grade, topic) => {
    const url = `/api/question-templates?filters[template_type][$eq]=AI_GENERATED&filters[topic][$eq]=${topic}&filters[grade][$eq]=${grade}&filters[is_verified][$eq]=true&pagination[limit]=-1`
    return useQuery(['approvedQuestions', grade, topic], async () => {
        let response = await HTTPClient.get().getJSONResult(url)
        return response["data"].map(a => ({ ...a, key: a.id }))
    });
};
function OptionView({ value }) {
    return (
        <div className='d-inline-block has-background-light px-3 py-1 mr-3'>{value}</div>
    )
}

const getColumns = () => {
    return [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Question',
            dataIndex: 'question',
            key: 'question',
        },
        {
            title: 'Answer',
            dataIndex: 'answer',
            key: 'answer',
        },
        {
            title: 'Options',
            dataIndex: 'options',
            render: (_, qt) => {
                return <>
                    <OptionView value={qt.option_1} />
                    <OptionView value={qt.option_2} />
                    <OptionView value={qt.option_3} />
                    <OptionView value={qt.option_4} />
                </>
            }
        },
    ]
};


export const assignQuestions = async ({ users, questions, topic }: { users: any, questions: any, topic: string }) => {
    console.log("Assigning Questions..", users, questions)
    try {
        // if (questions.length !== 3) {
        //     throw new Error("Please select 3 questions!")
        // }
        const url = `/api/tenant/assignQuestions`
        let data = {
            user_ids: users.map(u => u.id),
            question_ids: questions.map(q => q.id),
            topic,
            deleteExistingInTopic: true
        }
        let response = await HTTPClient.get().putDataForJSONResult(url, data)
        showSuccessToast("Done")
        return response
    } catch (error: any) {
        showErrorToast(error.message)
    }
}

const useMutateAssignQuestions = () => {
    return useMutation({
        mutationFn: assignQuestions
    })
}

export default function AssignQuestionsModal({ users, onClose }) {
    const [grade, setGrade] = useState("Grade 2")
    const [topic, setTopic] = useState("math")
    const { data: approvedQuestions, isLoading } = useApprovedQuestionTemplates(grade, topic);
    const [selectedRows, setSelectedRows] = useState<[]>([]);

    const { isLoading: isAssigning, mutateAsync: assignQuestions } = useMutateAssignQuestions()

    console.log(approvedQuestions, isAssigning)

    return (
        <Modal
            open
            onCancel={onClose}
            footer={null}
            width={"80vw"}
        >
            <h3 className='is-size-3 mb-5 between'>
                <strong>
                    Assign Questions
                </strong>
            </h3>
            <div>
                <div className='mb-5 between'>
                    <div>
                        <Select
                            className='mr-2'
                            value={grade}
                            style={{ width: 120 }}
                            onChange={(value) => {
                                console.log(value)
                                setGrade(value)
                            }}
                            options={GRADES}
                        />
                        <Select
                            value={topic}
                            style={{ width: 120 }}
                            onChange={(value) => {
                                console.log(value)
                                setTopic(value)
                            }}
                            options={TOPICS.map(t => ({ ...t, value: t.topic }))}
                        />
                    </div>
                    <div>
                        <Button
                            className='mr-2'
                            onClick={() => assignQuestions({ users, questions: selectedRows, topic })}>
                            Assign
                        </Button>
                    </div>

                </div>

                <Table
                    loading={isLoading}
                    rowSelection={{
                        onChange: (newSelectedRowKeys: React.Key[], selectedRows) => {
                            console.log(`selectedRowKeys: ${newSelectedRowKeys}`, 'selectedRows: ', selectedRows);
                            //@ts-ignore
                            setSelectedRows(selectedRows);
                        },
                        getCheckboxProps: (record) => ({
                            name: record.name,
                        }),
                    }}
                    dataSource={approvedQuestions}
                    columns={getColumns()}
                    pagination={{
                        defaultPageSize: 100
                    }}
                />
            </div>
        </Modal>
    )
}